export const contactForm = () => {
  const contactForm = document.getElementById('contactForm');
  if (!contactForm) return;
  // Enable submission after successful hCaptcha callbacks
  window.enableContactForm = () => document.getElementById('contactFormSubmit').disabled = false;
  window.disableContactForm = () => document.getElementById('contactFormSubmit').disabled = true;
};